import React from "react";

export const UiProgramCard = (props) => {
    return (
        <>

            <div className="sb-progm-card">
                <img src={props.image} />
                <h4>{props.title}</h4>

                { props.labelType == "featured" &&  <label className="sb-progm-card__featured">Featured</label> }
                { props.labelType == "new" &&  <label className="sb-progm-card__new">New</label> }
            
            </div>
        </>
    )
}